export default __webpack_public_path__ + "static/media/24_2_0.099a6554.png";